import { render, staticRenderFns } from "./JoinPassword.vue?vue&type=template&id=78c49862&scoped=true&"
import script from "./JoinPassword.vue?vue&type=script&lang=js&"
export * from "./JoinPassword.vue?vue&type=script&lang=js&"
import style0 from "./JoinPassword.vue?vue&type=style&index=0&id=78c49862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c49862",
  null
  
)

export default component.exports